import * as React from 'react';
import {withTranslation} from 'react-i18next';
import {compose} from "redux";
import {Field, InjectedFormProps, reduxForm} from "redux-form";
import {Validators} from "components/Layout/Form/Fields/Validators";
import RenderField from "components/Layout/Form/Fields/RenderField";

type ConnectedProps = {
    t?: Function;
};

class EditContractForm extends React.Component<InjectedFormProps & ConnectedProps> {

    public render() {
        const {t} = this.props;

        return (
            <form className="form">
                <Field
                    name="contractNumber"
                    component={RenderField}
                    type="text"
                    label={t('forms:newContractNumber')}
                    validate={[Validators.required]}
                />
            </form>
        );
    }
}

export default compose(
    withTranslation(['carDetails', 'forms', 'dictionary']),
    reduxForm({
        form: 'editContractForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    }))(EditContractForm) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/Contract/EditContractForm.tsx